import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { Button } from '@material-ui/core';
import { useStyles } from '@webapps/styles';

import styled from 'styled-components'
import { usePaymentContext } from '@webapps/reactjs-tech-components';

const Title = styled.h3`
    color: white;
`

const { NX_PROXY_API, NX_REDIRECT_URI } = process.env;

// This component represents Stripe payment form
export default function PaymentForm() {

  // Custom hook used to set payment status to true when stripe confirms all is OK
  // Store payment amount in state
  const { togglePayment, paymentAmount } = usePaymentContext();

  // Total amount to pay (*100 because stripe counts in cents)
  const totalAmount = paymentAmount * 100;

  // Define stripe & its elements
  const stripe = useStripe();
  const elements = useElements();

  // Define error messages on inputs
  const [errorMessage, setErrorMessage] = useState();

  // Define loading state
  const [loading, setLoading] = useState(false);

  // Function that handles error 
  const handleError = (error) => {
    setLoading(false);
    setErrorMessage(error.message);
  }

  // Style customization for Payment Form
  const paymentElementOptions = {
    layout: {
      type: 'accordion',
      radios: true,
      spacedAccordionItems: false
    }
    /* Other customization example
    layout: {
        type: 'tabs',
        
    }
    */
  }

  // Function that handle all logic when user clicks on "PAY" button
  const handleSubmit = async (event) => {
    // avoid page reload
    event.preventDefault();


    // Check Stripe presence, else return null
    if (!stripe) {
      return;
    }

    // Set loading state to true
    setLoading(true);

    // Trigger form validation and wallet collection
    const { error: submitError } = await elements.submit();
    if (submitError) {
      handleError(submitError);
      return;
    }

    // Create the PaymentIntent calling server
    const res = await fetch(`${NX_PROXY_API}/payment`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ totalAmount })
    });

    // Obtain client secret from server, after payment intent
    const { clientSecret } = await res.json();

    // Confirm the Payment using the details collected by the Payment Element
    // If intent results with no error, payment is confirmed
    stripe.confirmPayment({
      elements,
      clientSecret: clientSecret,
      confirmParams: {
        return_url: `${NX_REDIRECT_URI}/InscriptionOrganisme`, // TODO @Arnaud / @Quentin / @Mathieu : définir la route de redirection lorsque le paiement réussit
      },
      redirect: 'if_required'
    }).then(function (result) {
      if (result.error) {
        // If error during payment confirmation, show error message to user
        handleError(result.error);
      } else {
        // User is redirected to `return_url` (LINE 55). 
        // For some payment methods like iDEAL, your customer is redirected to an intermediate site first to authorize the payment, then redirected to the `return_url`.
        // TODO @Benoit :  SAVE BUSINESS DATA ON SERVER WHEN PAYMENT SUCCEEDS here or on server side
        togglePayment();
      }
    });
  };

  const {
    classes,
  } = useStyles(styles);

  // Displayed elements on screen (Payment form / pay button / errors)
  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement options={paymentElementOptions} />
      <Button
        className={classes.buttonSignin}
        color="primary"
        fullWidth
        variant="contained"
        type="submit" disabled={!stripe || loading}
      >
        {loading ? "Paiement..." : `Valider le paiement (${paymentAmount} €)`}

      </Button>
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  );
}

const styles = ({ fontSizes }) => ({
  buttonSignin: {
    marginTop: '20px',
  },
});